import {
  Button,
  Drawer,
  List,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import appRoutes from "../../routes/appRoutes";
import SidebarItem from "./SidebarItem";
import SidebarItemCollapse from "./SidebarItemCollapse";
import { useContext } from "react";
import { AuthContext } from "../../core/authContext";
import { roleKey } from "../../variables/constants";
import "./styles.scss";

const Sidebar = () => {
  const { user }: any = useContext(AuthContext);
  const role = user[roleKey];

  return (
    <Drawer variant="permanent" className="sidebar-drawer">
      <Toolbar className="sidebar-toolbar">
        <Stack className="stack-container">
          <Button href="/">
            <Typography className="header-title">TI Quest</Typography>
          </Button>
        </Stack>
      </Toolbar>
      <List disablePadding className="sidebar-list">
        {appRoutes.map((route) =>
          route?.roles?.includes(role ?? "") && route.sidebarProps ? (
            route.children ? (
              <SidebarItemCollapse item={route} key={route.path} />
            ) : (
              <SidebarItem item={route} key={route.path} />
            )
          ) : null
        )}
      </List>
    </Drawer>
  );
};

export default Sidebar;
